import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Admin/Sidebar';
import AdminHeader from '../../components/Admin/AdminHeader';
import useSubjectStore from '../../stores/subjectStore';
import { BsTrash } from 'react-icons/bs';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

function AdminSubjects() {
  const { subjects, fetchSubjects, addSubject, removeSubject, loading, error } = useSubjectStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [addError, setAddError] = useState(null);

  useEffect(() => {
    fetchSubjects();
    // eslint-disable-next-line
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    setAddError(null);
    try {
      await addSubject({ name });
      setName('');
      setModalOpen(false);
    } catch (e) {
      setAddError(e.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить предмет?')) return;
    try {
      await removeSubject(id);
    } catch (e) {}
  };

  return (
    <div className='AdminSubjects'>
      <div className="AdminSubjects__container">
        <Sidebar className="admin-sidebar" />
        <div className="content_admin">
          <AdminHeader
            title="Управление предметами"
            textButton="Добавить предмет"
            onButtonClick={() => { setModalOpen(true); setName(''); setAddError(null); }}
          />
          <div className="table__title" style={{ display: 'flex', gap: 16, alignItems: 'center', fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
            <div style={{ flex: 1 }}>Название предмета</div>
            <div style={{ width: 40 }}></div>
          </div>
          {loading && <div style={{ margin: 20 }}>Загрузка...</div>}
          {!loading && subjects.length === 0 && <div style={{ margin: 20, color: '#888' }}>Нет предметов</div>}
          <ul style={{ marginTop: 20, padding: 0, listStyle: 'none', maxWidth: 400 }}>
            {subjects.map((s) => (
              <li key={s._id} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '12px 0', borderBottom: '1px solid #ece9f7', background: '#fff', borderRadius: 8, marginBottom: 8, boxShadow: '0 1px 4px #ece9f7' }}>
                <span style={{ flex: 1, fontSize: 16 }}>{s.name}</span>
                <button onClick={() => handleDelete(s._id)} style={{ background: 'none', border: 'none', color: '#e74c3c', fontSize: 20, cursor: 'pointer', padding: 4 }} title="Удалить"><BsTrash /></button>
              </li>
            ))}
          </ul>
          {modalOpen && (
            <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div className="modal-content" style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 320, maxWidth: 400 }}>
                <h3 style={{ marginBottom: 20, textAlign: 'center' }}>Добавить предмет</h3>
                <form onSubmit={handleAdd}>
                  <div style={{ marginBottom: 16 }}>
                    <label>Название предмета:</label>
                    <input value={name} onChange={e => setName(e.target.value)} required style={{ width: '100%', marginTop: 4, fontSize: 16, padding: 8, borderRadius: 6, border: '1px solid #ccc' }} />
                  </div>
                  {addError && <div style={{ color: 'red', marginBottom: 8 }}>{addError}</div>}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                    <button type="button" onClick={() => setModalOpen(false)} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #ccc', background: '#f5f5f5', fontSize: 15 }}>Отмена</button>
                    <button type="submit" style={{ padding: '6px 16px', borderRadius: 6, background: '#6c3be4', color: '#fff', border: 'none', fontSize: 15 }} disabled={loading}>{loading ? 'Добавление...' : 'Добавить'}</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      <AdminBottomNavBar />
    </div>
  );
}

export default AdminSubjects; 